<template>
  <form
    class="upload-drag-show"
    @drop="droppedFile"
    @drag="preventDefault"
    @dragstart="preventDefault"
    @dragend="preventDefault"
    @dragover="preventDefault"
    @dragenter="preventDefault"
    @dragleave="preventDefault"
    :class="dropIndicatorActive"
  >
    <el-upload
      ref="el-upload"
      :action="action"
      :headers="headers"
      :file-list="fileList"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :on-add="onAdd"
      :data="data"
      :on-preview="handlePictureCardPreview"
      :on-error="onError"
      accept="image/*"
      :multiple="multiple"
      list-type="picture-card"
      class="upload-drag-show__upload-wrapper"
      :disabled="disabled"
    >
      <i style="pointer-events: none;" class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </form>
</template>

<script>
export default {
  props: {
    'file-list': {},
    'action': {},
    'headers': {},
    'on-add': {},
    'on-remove': {},
    'on-success': {},
    'on-error': {},
    'multiple': {},
    'data': {},
    'disabled': {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      isDropping: false,
    };
  },
  computed: {
    dropIndicatorActive() {
      // TODO: This function is disabled as it is still buggy.
      //       see https://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
      return (this.isDropping) ? 'dropping' : '';
    },
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    droppedFile(e) {
      // TODO: Need to perform file format validation against the accept list
      this.preventDefault(e);
      if (this.disabled) return;

      const uploader = this.$refs['el-upload'].$children.find(child => child.name === 'file');

      const files = [...e.dataTransfer.files];
      const areAllImages = files.every(fileObj => uploader.isImage(fileObj.type));

      if (!areAllImages) {
        this.$message('You can only upload images here');
      } else {
        uploader.uploadFiles(files);
      }
    },
    preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.upload-drag-show {
  padding: 1em 0;
  box-sizing: border-box;
  background-color: rgba(0,0,0,0.0);
  transition: background-color 0.5s;

  &.dropping {
    background-color: rgba(0,0,0,0.5);
  }
}

.is-disabled + .el-upload.el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/FilesMedia/UploadDragShow.vue